import { Dialog, DialogContent, DialogTitle, IconButton, lighten, useTheme } from '@mui/material';
import { ReactComponent as CloseIcon } from '../assets/icons/main/close-icon.svg';
import { useOutletContext } from 'react-router-dom';
import { get } from 'lodash';

const Styles = {
  dialog: {
    muiPaper: {
      maxWidth: '800px',
      padding: '21px 32px 32px',
      width: '800px',
      borderRadius: '18px',
    },
    // '& .MuiPaper-root:not(.MuiAccordion-root)': {
    // maxWidth: '800px',
    // padding: '21px 32px',
    // width: '800px',
    // borderRadius: '18px',
    //   backgroundColor: `${palette.transparent.main}`,
    // },
    // '&.MuiPaper-root.MuiDialog-root': {
    //   maxWidth: '800px',
    //   padding: '21px 32px',
    //   width: '800px',
    //   borderRadius: '18px',
    //   backgroundColor: `${palette.transparent.main}`,
    // },
  },
  dialogTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '1.3rem',
    padding: '0px 0px 21px 0px',
    fontFamily: 'Open Sans',
    fontWeight: '400',
  },
  content: {
    '&.MuiDialogContent-root': {
      padding: '0px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItem: 'center',
      borderRadius: '18px',
    },
  },
  closeIcon: {
    cursor: 'pointer',
  },
};

const Modal = ({
  children, title, open, handleClose = () => {
  }, dialogContentStyles = {}, customStyles = {}, containerStyles = {}
}: any) => {
  const themeData: any = useTheme();
  return (
    <Dialog
      open={open}
      fullWidth
      sx={{ ...Styles.dialog, ...containerStyles }}
      PaperProps={{
        sx: { ...Styles.dialog.muiPaper, ...customStyles, backgroundColor: themeData.palette.background.default },
      }}
    // onClose={() => {
    //   handleClose();
    // }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ ...Styles.dialogTitle, color: themeData.palette.text.primary }}>
        {title}
        <IconButton
          onClick={() => {
            handleClose();
          }}>
          <CloseIcon style={{...Styles.closeIcon, color:themeData.palette.custom.light }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ ...Styles.content, padding: '0px !important'}} className='modalDialogContent'>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;